import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SummaryWrapper } from '@app/wrappers/summary-wrapper/summary-wrapper';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import {ThemeModule} from '@app/themes/theme-module';
import {IMenuItem} from '@models/i-menu-item';
import {MenuChildrenPipe} from '@app/utils/pipes/menu-children.pipe';
import {SummaryParent} from '@app/wrappers/summary-parent';

interface SummaryData {
  model: string;
  module: string;
  version: string;
  description: string;
  lastRunDate: string;
  status: 'Active' | 'Processing' | 'Badge';
  result: string;
}

@Component({
  selector: 'app-crop-identification-page',
  standalone: true,
  imports: [CommonModule, TranslateModule, ThemeModule, TableModule, ButtonModule, CardModule, MenuChildrenPipe],
  templateUrl: './crop-identification-main.component.html',
  styleUrls: ['./crop-identification-main.component.scss'],
})
export class CropIdentificationMainComponent extends SummaryParent implements OnInit {


  summaryData: SummaryData[] = [
    {
      model: 'Модель определения границ полей',
      module: 'Гис',
      version: 'V.01',
      description: 'Определения границ полей',
      lastRunDate: '23.03.2025',
      status: 'Active',
      result: 'Найденно 200 контуров полей, 95 % совпадений с кадастром',
    },
    {
      model: 'Модель Детекции культур',
      module: 'Версия',
      version: 'Версия',
      description: 'Текст',
      lastRunDate: '23.03.2025',
      status: 'Processing',
      result: '95,2 % точность определения культур',
    },
    {
      model: 'Модель',
      module: 'Версия',
      version: 'Версия',
      description: 'Текст',
      lastRunDate: '23.03.2025',
      status: 'Badge',
      result: 'Badge',
    },
    {
      model: 'Модель',
      module: 'Версия',
      version: 'Версия',
      description: 'Текст',
      lastRunDate: '23.03.2025',
      status: 'Badge',
      result: 'Badge',
    },
  ];

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {}

  onExport(): void {

  }
}
